
export default {
  computed: {
    $getBaseUrl () {
      return 'https://woningselector.nl'
    },
    $getAllObjects () {
      return this.$store.state.apiData.objects
    },
    $getGlobalData () {
        return this.$store.state.apiData
    },
    $loggedIn () {
      return !! this.$store.state.userToken
    },
    $user () {
      return this.$store.state.user.email ? this.$store.state.user : null
    },
    $selectorId () {
      if(this.$store.state.apiData){
        return this.$store.state.apiData.reference
      }
      return ''
    },
    $favorites () {
      let ids = this.$store.state.favorites;
      let objects = []
      ids.forEach((id) => {
        let object = this.$store.state.apiData.objects.find((object) => {
          return object.id === id
        })
        if(object) {
          objects.push(object)
        }
      })
      return objects
    },
    $assignable () {
      let max = this.$store.state.maxRentalPrice
      return this.$favorites.filter((object) => {
        return object.price_value <= max
      })
    },
    $notAssignable () {
      let max = this.$store.state.maxRentalPrice * 1.15;
      return this.$favorites.filter((object) => {
        return object.price_value > max
      })
    },
    $likelyNotAssignable () {
      let max = this.$store.state.maxRentalPrice
      let max_top = this.$store.state.maxRentalPrice * 1.15;
      return this.$favorites.filter((object) => {
        return object.price_value > max && object.price_value < max_top
      })
    },
    $highlight () {
      return this.$store.state.apiData.highlight
    }
  },
  methods: {
    $clone(v) {
      return JSON.parse(JSON.stringify(v))
    },
    $login () {
      this.$store.commit('lastPage', window.location.pathname)
      window.location.href = 'https://woningselector.nl/cubiceyes/auth/login?id=' + this.$selectorId + '&origin=' + window.location.origin + '/'
    },
    $logout () {
      this.$store.commit('lastPage', window.location.pathname)
      window.location.href = 'https://woningselector.nl/cubiceyes/auth/logout?token=' + this.$store.state.userToken + '&origin=' + window.location.origin + '/'
    },
    $getObject (id) {
      return this.$store.state.apiData.objects.find((object) => {
        return object.id.toString() === id.toString()
      })
    },


    $getUser () {
      return new Promise((resolve) => {
        if(!this.$store.state.userToken){
          resolve()
          return
        }
        this.axios.get(this.$route.params.selector_id + '/users/' + this.$store.state.userToken).then((result) => {
          this.$store.commit('setUser', result.data)
          resolve()
        }).catch(() => {
          this.$store.commit('setUserToken', null)
          this.$store.commit('setUser', {})
          resolve()
        })
      })
    },

  }
}

